<template>
    <div class="vx-row" style="padding: 0 1rem;">
        <vs-col vs-lg="6" vs-xs="12">
            <div class="mb-1 text-primary" style="font-weight: 500;">{{load.name}}</div>
        </vs-col>
        <vs-col vs-lg="6" vs-xs="12">
            <div class="vx-row">
                <vs-col class="px-1" vs-lg="6" vs-xs="12">
                    <multiselect
                        v-model="load.lang"
                        label="language_name"
                        name="lang"
                        :options="[load.lang]"
                        placeholder="Язык"
                        style="width: 100%;overflow: hidden;"
                        :disabled="true"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'" >
                        <div slot="noOptions">{{$t('no_data_text')}}</div>
                    </multiselect>
                </vs-col>
                <vs-col class="px-1" vs-lg="6" vs-xs="12">
                    <multiselect
                        v-model="load.teacher"
                        :options="[load.teacher]"
                        label="teacher_name"
                        name="teacher"
                        selectLabel=""
                        selectedLabel=""
                        placeholder="Преподаватель"
                        style="width: 100%;"
                        :disabled="true"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"  >
                    </multiselect>
                </vs-col>
            </div>
        </vs-col>
    </div>
</template>

<script>
export default {
    name: "NotControlForms",
    props:{
        load:Object,
    }
};
</script>

<style scoped>

</style>
